import { BlogPost } from '../api/blogPosts';

/**
 * Get the title in the specified language
 */
export const getBlogTitle = (blogPost: BlogPost, language: string): string => {
  switch (language) {
    case 'zh':
      return blogPost.titleZh || blogPost.title;
    case 'cn':
      return blogPost.titleCn || blogPost.title;
    default:
      return blogPost.title;
  }
};

/**
 * Get the content in the specified language
 */
export const getBlogContent = (blogPost: BlogPost, language: string): string => {
  switch (language) {
    case 'zh':
      return blogPost.contentZh || blogPost.content;
    case 'cn':
      return blogPost.contentCn || blogPost.content;
    default:
      return blogPost.content;
  }
};

/**
 * Get the SEO title in the specified language
 */
export const getBlogSeoTitle = (blogPost: BlogPost, language: string): string | null => {
  switch (language) {
    case 'zh':
      return blogPost.seoTitleZh || blogPost.seoTitle;
    case 'cn':
      return blogPost.seoTitleCn || blogPost.seoTitle;
    default:
      return blogPost.seoTitle;
  }
};

/**
 * Get the SEO description in the specified language
 */
export const getBlogSeoDescription = (blogPost: BlogPost, language: string): string | null => {
  switch (language) {
    case 'zh':
      return blogPost.seoDescriptionZh || blogPost.seoDescription;
    case 'cn':
      return blogPost.seoDescriptionCn || blogPost.seoDescription;
    default:
      return blogPost.seoDescription;
  }
};
